// @flow
import * as React from 'react';
import { Box } from 'gestalt';

export default function ProgressBar({ progress, height }: { progress: number, height: number }) {
  return (
    <Box color="lightGray" height={height} position="relative">
      <Box
        height="100%"
        width="100%"
        color="darkGray"
        top
        left
        position="absolute"
        dangerouslySetInlineStyle={{
          __style: {
            transformOrigin: 'left',
            transition: '1s transform',
            transform: `scaleX(${progress})`,
          },
        }}
      />
    </Box>
  );
}
